module.exports = __webpack_public_path__ + "static/media/chevronUp.80b50687.svg";